import React, { createContext } from "react";
import data from '../lang/de-build.json';
// import data from '../lang/de-site.json';

const DataContext = createContext();

const Version = data.version;

function DataProvider( { children } ) {
    return (
        <DataContext.Provider value={ { data } }>
            { children }
        </DataContext.Provider>
    );
}

export {
    DataContext,
    DataProvider,
    Version,
}